import { engineComponent } from "neo-common";
import { ILayoutElement } from "./ILayoutElement";
import { ShapeElement, ShapeElementAttributes } from "../Components/Elements/Graphics/ShapeElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { LayoutManager } from "../Managers/LayoutManager";
import { StageController } from "../Components/StageController";

@engineComponent(ComponentTypes.DisplayObject)
export class LayoutShapeElement extends ShapeElement implements ILayoutElement {
    protected relativeWidth: number;

    protected relativeHeight: number;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();
        this.relativeWidth = -1;
        this.relativeHeight = -1;
        LayoutManager.addLayoutElement(this);
    }

    updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.hasAttribute(ShapeElementAttributes.WIDTH)) {
            let width = node.getAttribute(ShapeElementAttributes.WIDTH);
            this._width = parseInt(width);

            this.relativeWidth = width.indexOf("%") > -1 ? parseInt(width) : -1;
            if (this.relativeWidth > -1) {
                this._width = StageController.Renderer.screen.width * (this.relativeWidth * 0.01);
            }
            this.redrawRect();
        }

        if (node.hasAttribute(ShapeElementAttributes.HEIGHT)) {
            let height = node.getAttribute(ShapeElementAttributes.HEIGHT);
            this._height = parseInt(height);

            this.relativeHeight = height.indexOf("%") > -1 ? parseInt(height) : -1;
            if (this.relativeHeight > -1) {
                this._height = StageController.Renderer.screen.height * (this.relativeHeight * 0.01);
            }
            this.redrawRect();
        }
    }

    private redrawRect(): void {
        this.clear();
        this.beginFill(this._color, this._fillAlpha);
        this.lineStyle(this._lineWidth, this._lineColor);
        this.drawRect(0, 0, this._width, this._height);
        this.endFill();
    }

    onLayoutChange(isPortrait: boolean): void {
        if (this.relativeWidth > -1) {
            this._width = StageController.Renderer.screen.width * (this.relativeWidth * 0.01);
        }

        if (this.relativeHeight > -1) {
            this._height = StageController.Renderer.screen.height * (this.relativeHeight * 0.01);
        }

        this.redrawRect();
    }

    clone(): LayoutShapeElement {
        let element: LayoutShapeElement = new LayoutShapeElement();
        element.create(this._nodeDefinition);

        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.relativeWidth = this.relativeWidth;
        element.relativeHeight = this.relativeHeight;

        return element;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/LayoutShapeElement.ts
 **/